/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */

import * as Models from '@models';
import * as Services from '@services';
import { Utils } from '@utils';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
class TenantStore {
  tenants = new Map<number, Services.GetAllTenantOutput>();
  totalCount: number = 0;
  skipCount: number = 0;
  loading: boolean = false;
  tenantBankAccount!: Services.TenantBankAccount;
  tenantModel!: Models.TenantModel;
  tenantProfile!: Services.TenantProfile;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  async create(createTenantInput: Services.CreateTenantInput) {
    this.setLoading(true);
    try {
      const website = Utils.configureUrl(createTenantInput.tenantProfile.website);
      const input: Services.CreateTenantInput = {
        ...createTenantInput,
        tenantProfile: { ...createTenantInput.tenantProfile, website },
      };
      const result = await Services.TenantService.create(input);

      runInAction(() => {
        const newUser = result;

        // Add the new customer to the beginning of the map
        const tempArray = Array.from(this.tenants.entries());
        tempArray.unshift([newUser.id, newUser]);

        // If there are more than 10 tenants, remove the oldest one
        if (tempArray.length > 10) {
          tempArray.pop();
        }

        // Clear the map and add the updated list back to it
        this.tenants.clear();
        tempArray.forEach(([id, user]) => {
          this.tenants.set(id, user);
        });

        this.totalCount += 1;
      });
      this.setLoading(false);
      message.success({
        content: 'Successfully created!',
      });
      return result;
    } catch (error) {
      this.setLoading(false);
      console.error(error);
      return null;
    }
  }

  async update(updateTenantInput: Services.UpdateTenantInput) {
    this.setLoading(true);
    try {
      const result = await Services.TenantService.update(updateTenantInput);
      runInAction(() => {
        this.tenants.set(result.id, result);
      });
      this.setLoading(false);
    } catch (error) {
      console.error(error);
      this.setLoading(false);
    }
  }

  async delete(entityDto: Services.EntityDto) {
    await Services.TenantService.delete(entityDto);
    runInAction(() => {
      this.tenants.delete(entityDto.id);
      this.totalCount -= 1;
    });
  }

  async get(entityDto: Services.EntityDto) {
    const result = await Services.TenantService.get(entityDto);
    runInAction(() => {
      this.tenantModel = result;
    });
  }

  async getAll(pagedFilterAndSortedRequest: Services.PagedTenantResultRequestDto) {
    this.setLoading(true);
    try {
      const result = await Services.TenantService.getAll(pagedFilterAndSortedRequest);
      runInAction(() => {
        result.items.forEach((tenant) => {
          this.tenants.set(tenant.id, tenant);
        });
        this.totalCount = result.totalCount;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async getBankAccount(entityDto: Services.EntityDto) {
    this.setLoading(true);
    try {
      const result = await Services.TenantService.getBankAccount(entityDto);
      runInAction(() => {
        this.tenantBankAccount = result;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async createOrUpdateBankAccount(input: Services.UpdateTenantBankAccount) {
    try {
      const result = await Services.TenantService.createOrUpdateBankAccount(input);
      runInAction(() => {
        this.tenantBankAccount = result;
      });
      message.success({
        content: 'Successfully updated!',
      });
    } catch (error) {
      console.error(error);
    }
  }

  async informationChangeRequest(input: Services.InformationChangeRequest) {
    try {
      await Services.TenantService.informationChangeRequest(input);

      message.success({
        content: 'Successfully sent!',
      });
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Failed to send!',
      });
    }
  }

  setSkipCount = (value: number) => {
    runInAction(() => {
      this.skipCount = value;
    });
  };
}

export default TenantStore;
